module.exports = __webpack_public_path__ + "img/pooja.3742361d.svg";